import * as React from "react";
export const SvgClear = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
		<path
			fill="#A8A8A8"
			d="M10 2a8 8 0 1 0 8 8 8.016 8.016 0 0 0-8-8Zm2.9 10.023a.623.623 0 0 1 0 .877.63.63 0 0 1-.877 0L10 10.87 7.977 12.9a.63.63 0 0 1-.877 0 .623.623 0 0 1 0-.877L9.13 10 7.1 7.977a.623.623 0 0 1 .877-.877L10 9.13l2.023-2.03a.623.623 0 0 1 .877.877L10.87 10l2.03 2.023Z"
		/>
	</svg>
);
